import { useState } from 'react'
import { useAuthContext } from './useauthContext'
import axios from 'axios'
import Cookies from 'js-cookie'
import { API_URL } from '../config';

export const useLogin = () => {
  const [error, setError] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const { dispatch } = useAuthContext()

  const login = async (email, password) => {
    setIsLoading(true)
    setError(null)

    try {
      const response = await axios.post(`${API_URL}/login`, { email, password })
      const json = response.data
      console.log(json)

      // Optionally, still store the user in localStorage for app state management
      // localStorage.setItem('user', JSON.stringify(json))

      // Update the auth context
      dispatch({ type: 'LOGIN', payload: json })

      setIsLoading(false)
      return json  // Return user data on success
    } catch (err) {
      console.log("Error response:", err.response)

      const errorMessage =
        (err.response &&
          (err.response.data?.detail ||
           err.response.data?.error ||
           err.response.data)) ||
        err.message ||
        'Login failed'
        
      setError(errorMessage)
      setIsLoading(false)
      return null  // Indicate failure
    }
  }

  return { login, isLoading, error }
}
